import React, { useState } from 'react';
import { Line as LineChart } from 'react-chartjs-2';
import { Collapse } from 'react-bootstrap';
import VisibilitySensor from 'react-visibility-sensor';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

const Loanprogress = () => {
    const [open, setOpen] = useState(true);

    const [progressConfig] = useState({
        headerTitle: "LOAN PROGRESS CHARTS",
        repaymentProgressTitle: "Repayment Progress",
        repaymentTrackingTitle: "Repayment Tracking",
        outstandingBalance: { label: "Outstanding balance", value: "$ 10,000" },
        paidToDate: { label: "Paid to date", value: "$ 1,257" },
        avgPayment: { label: "Average Payment", value: "$ 57,975" },
        estTimeToRepay: { label: "Estimated time to repay", value: "1 month(s)" },
        percentage: 78,
    });

    const [chartData] = useState({
        labels: ["Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
        datasets: [{
            label: "",
            borderColor: "#0070ba",
            backgroundColor: "#0070ba",
            borderWidth: 0,
            fill: true,
            data: [200, 175, 150, 125, 100, 75, 50, 25, 0],
        }],
    });

    const [smallChartData] = useState({
        labels: ["", "", "", "", "", "", "", "", "", "", ""],
        datasets: [{
            label: "",
            borderColor: "#0070ba",
            backgroundColor: "#0070ba",
            borderWidth: 0,
            fill: true,
            data: [200, 175, 150, 125, 100, 75, 50, 25, 0],
        }],
    });

    const [chartOptions] = useState({
        legend: { display: false },
        scales: {
            yAxes: [{
                ticks: {
                    fontColor: "rgba(0,0,0,0.5)",
                    fontStyle: "bold",
                    beginAtZero: true,
                    maxTicksLimit: 5,
                    padding: 20,
                },
                gridLines: { drawTicks: false, display: false },
            }],
            xAxes: [{
                gridLines: { zeroLineColor: "transparent" },
                ticks: {
                    padding: 20,
                    fontColor: "rgba(0,0,0,0.5)",
                    fontStyle: "bold",
                },
            }],
        },
    });

    const [smallChartOptions] = useState({
        legend: { display: false },
        scales: {
            yAxes: [{ gridLines: { zeroLineColor: "transparent" }, ticks: { display: false } }],
            xAxes: [{ gridLines: { zeroLineColor: "transparent" }, ticks: { display: false } }],
        },
    });

    return (
        <div className="col-12">
            <div className="dashboard-second-sec" onClick={() => setOpen(!open)}>
                <div className="row">
                    <div className="col-lg-4 col-md-6 align-self-center">
                        <div className="heading-text">
                            <h4 className="text-custom-black no-margin">{progressConfig.headerTitle}</h4>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-6">
                        <div className="right-side">
                            <div className="pie-chart-box">
                                <div className="active-border activeBorder">
                                    <div className="circle circlestyle">
                                        <VisibilitySensor>
                                            {({ isVisible }) => (
                                                <CircularProgressbar
                                                    value={isVisible ? progressConfig.percentage : 0}
                                                    text={`${isVisible ? progressConfig.percentage : 0}%`}
                                                    strokeWidth={7}
                                                    styles={buildStyles({
                                                        pathColor: `rgba(17, 195, 145, 1)`,
                                                        textColor: '#000000',
                                                        trailColor: '#0070ba',
                                                    })}
                                                />
                                            )}
                                        </VisibilitySensor>
                                    </div>
                                </div>
                            </div>
                            <div className="line-chart-box">
                                <div className="graph">
                                    <LineChart data={smallChartData} options={smallChartOptions} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Collapse in={open}>
                <div className="dashboard-second-sec-large">
                    <div className="row">
                        <div className="col-lg-5">
                            <h5 className="text-custom-black fw-600 text-center mb-xl-40">{progressConfig.repaymentProgressTitle}</h5>
                            <div className="left-side mb-md-40">
                                <div className="pie-chart-area">
                                    <div className="active-border activeBorder">
                                        <div className="circle circlestyle-big">
                                            <VisibilitySensor>
                                                {({ isVisible }) => (
                                                    <CircularProgressbar
                                                        value={isVisible ? progressConfig.percentage : 0}
                                                        text={`${isVisible ? progressConfig.percentage : 0}%`}
                                                        strokeWidth={3}
                                                        styles={buildStyles({
                                                            pathColor: `rgba(17, 195, 145, 1)`,
                                                            textColor: '#000000',
                                                            trailColor: '#0070ba',
                                                        })}
                                                    />
                                                )}
                                            </VisibilitySensor>
                                        </div>
                                    </div>
                                </div>
                                <div className="pie-chart-area-text">
                                    <div className="text-wraper mb-xl-20">
                                        <label className="fw-600 fs-16 text-custom-black">{progressConfig.outstandingBalance.value}</label>
                                        <p className="no-margin fw-500 text-custom-black">{progressConfig.outstandingBalance.label}</p>
                                    </div>
                                    <div className="text-wraper">
                                        <label className="fw-600 fs-16 text-custom-black">{progressConfig.paidToDate.value}</label>
                                        <p className="no-margin fw-500 text-custom-black">{progressConfig.paidToDate.label}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-7">
                            <h5 className="text-custom-black fw-600 text-center mb-xl-40">{progressConfig.repaymentTrackingTitle}</h5>
                            <div className="right-side">
                                <div className="graph mb-xs-40">
                                    <LineChart data={chartData} options={chartOptions} />
                                </div>
                                <div className="graph-text">
                                    <div className="text-wraper mb-xl-20">
                                        <label className="fw-600 fs-16 text-custom-black">{progressConfig.avgPayment.label}</label>
                                        <p className="no-margin fw-500 text-custom-black">{progressConfig.avgPayment.value}</p>
                                    </div>
                                    <div className="text-wraper">
                                        <label className="fw-600 fs-16 text-custom-black">{progressConfig.estTimeToRepay.label}</label>
                                        <p className="no-margin fw-500 text-custom-black">{progressConfig.estTimeToRepay.value}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Collapse>
        </div>
    );
};

export default Loanprogress;
